"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8242],{

/***/ 68242:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DE": function() { return /* binding */ ClaimTrackingSegements; },
/* harmony export */   "HL": function() { return /* binding */ EWFnolPages; },
/* harmony export */   "Hi": function() { return /* binding */ EWFnolViewEvents; },
/* harmony export */   "Jk": function() { return /* binding */ SegmentTrackEvents; },
/* harmony export */   "Lf": function() { return /* binding */ ElectronicsFnolViewEvents; },
/* harmony export */   "QD": function() { return /* binding */ ElectronicsPolicyDetailsSegments; },
/* harmony export */   "Qe": function() { return /* binding */ MPosSegmentViewEvents; },
/* harmony export */   "So": function() { return /* binding */ ElectronicsFnolPages; },
/* harmony export */   "_L": function() { return /* binding */ ElectronicsFnolTrackEvents; },
/* harmony export */   "bC": function() { return /* binding */ InternetFnolViewEvents; },
/* harmony export */   "ey": function() { return /* binding */ MPosSegementTrackEvents; },
/* harmony export */   "iE": function() { return /* binding */ MPosSegmentPages; },
/* harmony export */   "m9": function() { return /* binding */ InternetFnolPages; },
/* harmony export */   "od": function() { return /* binding */ SegmentViewEvents; },
/* harmony export */   "p3": function() { return /* binding */ InternetFnolPageTypes; },
/* harmony export */   "px": function() { return /* binding */ PartnershipPolicySegments; },
/* harmony export */   "qM": function() { return /* binding */ ElectronicsPolicyEditSegments; },
/* harmony export */   "rw": function() { return /* binding */ EWFnolTrackEvents; },
/* harmony export */   "xq": function() { return /* binding */ InternetFnolButton; },
/* harmony export */   "yI": function() { return /* binding */ InternetFnolTrackEvents; },
/* harmony export */   "zR": function() { return /* binding */ ElectronicsPolicyDetailsViewEvents; }
/* harmony export */ });
var PartnershipPolicySegments;
(function(PartnershipPolicySegments) {
    PartnershipPolicySegments["VIEW_INTERNET_POLICY_PAGE"] = "view_internet_policy_page";
    PartnershipPolicySegments["TAP_BTN_CLAIM"] = "tap_btn_claim";
    PartnershipPolicySegments["TAP_ONGOING_CLAIMS_CTA"] = "tap_ongoing_claims_cta";
    PartnershipPolicySegments["TAP_BTN_DOWNLOAD_POLICY"] = "tap_btn_download_policy";
    PartnershipPolicySegments["TAP_SHARE_POLICY_CTA"] = "tap_share_policy_cta";
    PartnershipPolicySegments["TAP_ADD_DEPENDENT"] = "tap_add_dependent";
    PartnershipPolicySegments["TAP_ADD_DEPENDENT_SUBMIT"] = "tap_add_dependent_submit";
    PartnershipPolicySegments["TAP_ADD_NOMINEE"] = "tap_add_nominee";
    PartnershipPolicySegments["TAP_ADD_NOMINEE_SUBMIT"] = "tap_add_nominee_submit";
    PartnershipPolicySegments["TAP_BTN_PDP_DOWNLOAD_APP"] = "tap_btn_pdp_download_app";
})(PartnershipPolicySegments || (PartnershipPolicySegments = {}));
var ClaimTrackingSegements;
(function(ClaimTrackingSegements) {
    ClaimTrackingSegements["TAP_CLAIM_WITHDRAWN"] = "tap_claim_withdrawn";
    ClaimTrackingSegements["TAP_CLAIM_BREAKUP"] = "tap_claim_breakup";
    ClaimTrackingSegements["TAP_UPLOAD_DOCUMENT_CTA"] = "tap_upload_document_cta";
    ClaimTrackingSegements["TAP_PAYMENT_DETAILS_CTA"] = "tap_payment_details_cta";
    ClaimTrackingSegements["TAP_RETRY_RAISE_REPAIR_REQUEST"] = "tap_retry_raise_repair_request";
    ClaimTrackingSegements["TAP_WITHDRAW_REQUEST_INITIATE"] = "tap_withdraw_request_initiate";
    ClaimTrackingSegements["TAP_WITHDRAW_REQUEST_SUBMIT"] = "tap_withdraw_request_submit";
})(ClaimTrackingSegements || (ClaimTrackingSegements = {}));
var ElectronicsPolicyDetailsViewEvents;
(function(ElectronicsPolicyDetailsViewEvents) {
    ElectronicsPolicyDetailsViewEvents["VIEW_PAGE_PDP"] = "view_page_pdp";
    ElectronicsPolicyDetailsViewEvents["VIEW_PAGE_REQUEST_WITHDRAW_SUCCESS_POPUP"] = "view_page_request_withdrawn_success_popup";
})(ElectronicsPolicyDetailsViewEvents || (ElectronicsPolicyDetailsViewEvents = {}));
var ElectronicsPolicyDetailsSegments;
(function(ElectronicsPolicyDetailsSegments) {
    ElectronicsPolicyDetailsSegments["TAP_RAISE_REPAIR_REQUEST"] = "tap_raise_repair_request";
    ElectronicsPolicyDetailsSegments["TAP_DOWNLOAD_POLICY_DOCUMENT"] = "tap_download_policy_document";
    ElectronicsPolicyDetailsSegments["TAP_TRACK_REPAIR_BUBBLE"] = "tap_track_repair_bubble";
    ElectronicsPolicyDetailsSegments["TAP_EDIT_POLICY_DETAILS_CTA"] = "tap_edit_policy_details_cta";
    ElectronicsPolicyDetailsSegments["TAP_OVERVIEW_TAB"] = "tap_overview_tab";
    ElectronicsPolicyDetailsSegments["TAP_FAQ_TAB"] = "tap_faq_tab";
    ElectronicsPolicyDetailsSegments["TAP_ADD_MORE_DETAILS_CTA"] = "tap_add_more_details_cta";
    ElectronicsPolicyDetailsSegments["TAP_ADD_MORE_DETAILS_SUBMIT"] = "tap_add_more_details_submit";
    ElectronicsPolicyDetailsSegments["TAP_EDIT_POLICY_HOLDER_DETAILS_CTA"] = "tap_edit_policy_holder_details_cta";
    ElectronicsPolicyDetailsSegments["TAP_KNOW_MORE"] = "tap_know_more";
    ElectronicsPolicyDetailsSegments["TAP_PDP_FAQ_KNOW_MORE"] = "tap_pdp_faq_know_more";
    ElectronicsPolicyDetailsSegments["TAP_PDP_HELP_PAGES_CTA"] = "tap_pdp_help_pages_cta";
    ElectronicsPolicyDetailsSegments["TAP_GET_VOUCHER_CTA"] = "tap_get_voucher_cta";
    ElectronicsPolicyDetailsSegments["TAP_BTN_REPAIR_REQUEST_PDP_PAGE"] = "tap_btn_repair_request_pdp_page";
})(ElectronicsPolicyDetailsSegments || (ElectronicsPolicyDetailsSegments = {}));
var ElectronicsPolicyEditSegments;
(function(ElectronicsPolicyEditSegments) {
    ElectronicsPolicyEditSegments["TAP_UPDATE_PRODUCT_ORDER_ID"] = "tap_update_product_order_id";
    ElectronicsPolicyEditSegments["TAP_UPDATE_SERIAL_NUMBER"] = "tap_update_serial_number";
    ElectronicsPolicyEditSegments["TAP_UPLOAD_DOCUMENT"] = "tap_upload_document";
    ElectronicsPolicyEditSegments["TAP_VIEW_SAMPLE_DOCUMENT"] = "tap_view_sample_document";
    ElectronicsPolicyEditSegments["TAP_EDIT_DETAILS_CONTINUE"] = "tap_edit_details_continue";
})(ElectronicsPolicyEditSegments || (ElectronicsPolicyEditSegments = {}));
var ElectronicsFnolViewEvents;
(function(ElectronicsFnolViewEvents) {
    ElectronicsFnolViewEvents["VIEW_PAGE_IMEI"] = "view_page_imei";
    ElectronicsFnolViewEvents["VIEW_PAGE_IMEI_CONFIRMATION_POPUP"] = "view_page_imei_confirmation_popup";
    ElectronicsFnolViewEvents["VIEW_PAGE_MOBILE_DAMAGE_TYPE"] = "view_page_mobile_damage_type";
    ElectronicsFnolViewEvents["VIEW_PAGE_PINCODE"] = "view_page_pincode";
    ElectronicsFnolViewEvents["VIEW_PAGE_MODE_OF_SETTLEMENT"] = "view_page_mode_of_settlement";
    ElectronicsFnolViewEvents["VIEW_PAGE_ADD_SPARE_PHONE"] = "view_page_add_spare_phone";
    ElectronicsFnolViewEvents["VIEW_PAGE_PICK_UP_ADDRESS_DETAILS"] = "view_page_pick_up_address_details";
    ElectronicsFnolViewEvents["VIEW_PAGE_UPLOAD_PHOTOS"] = "view_page_upload_photos";
    ElectronicsFnolViewEvents["VIEW_PAGE_SERVICE_CENTER_DETAILS"] = "view_page_service_center_details ";
    ElectronicsFnolViewEvents["VIEW_PAGE_TRANSFER_OPTION"] = "view_page_transfer_option";
    ElectronicsFnolViewEvents["VIEW_PAGE_UPI_DETAILS"] = "view_page_upi_details";
    ElectronicsFnolViewEvents["VIEW_PAGE_BANK_DETAILS"] = "view_page_bank_details";
    ElectronicsFnolViewEvents["VIEW_PAGE_REVIEW_REQUEST_DETAILS"] = "view_page_review_request_details ";
    ElectronicsFnolViewEvents["VIEW_PAGE_REQUEST_REGISTERED"] = "view_page_request_registered";
    ElectronicsFnolViewEvents["VIEW_PAGE_TRACK_REPAIR_REQUEST"] = "view_page_track_repair_request";
    ElectronicsFnolViewEvents["VIEW_PAGE_CONFIRM_CLAIM_WITHDRAW_POPUP"] = "view_page_confirm_claim_withdraw_popup";
    ElectronicsFnolViewEvents["VIEW_PAGE_INCIDENT_DETAILS"] = "view_page_incident_details";
})(ElectronicsFnolViewEvents || (ElectronicsFnolViewEvents = {}));
var ElectronicsFnolTrackEvents;
(function(ElectronicsFnolTrackEvents) {
    ElectronicsFnolTrackEvents["TAP_BTN_BACK"] = "tap_btn_back";
    ElectronicsFnolTrackEvents["TAP_BTN_IMEI_PAGE"] = "tap_btn_imei_page";
    ElectronicsFnolTrackEvents["TAP_BTN_IMEI_PAGE_CONFIRMATION_POPUP"] = "tap_btn_imei_page_confirmation_popup";
    ElectronicsFnolTrackEvents["TAP_BTN_MOBILE_DAMAGE_TYPE"] = "tap_btn_mobile_damage_type";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_MOBILE_DAMAGE_TYPE_PAGE"] = "tap_btn_continue_mobile_damage_type_page";
    ElectronicsFnolTrackEvents["TAP_BTN_INCIDENT_DATE_INCIDENT_DETAIL_PAGE"] = "tap_btn_incident_date_incident_detail_page";
    ElectronicsFnolTrackEvents["TAP_BTN_INCIDENT_DESCRIPTION_INCIDENT_DETAIL_PAGE"] = "tap_btn_incident_description_incident_detail_page";
    ElectronicsFnolTrackEvents["TAP_INPUT_INCIDENT_DESCRIPTION_INCIDENT_DETAIL_PAGE"] = "tap_input_incident_description_incident_detail_page";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_INCIDENT_DETAIL_PAGE"] = "tap_btn_continue_incident_detail_page";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_PINCODE_PAGE"] = "tap_btn_continue_pincode_page";
    ElectronicsFnolTrackEvents["TAP_BTN_SELECT_MODE_OF_SETTLEMENT_PAGE"] = "tap_btn_select_mode_of_settlement_page";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_PICK_UP_ADDRESS_DETAILS"] = "tap_btn_continue_pick_up_address_details";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_UPLOAD_PHOTOS"] = "tap_btn_continue_upload_photos";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_SPARE_PHONE"] = "tap_btn_continue_spare_phone";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_SERVICE_CENTER_DETAILS"] = "tap_btn_continue_service_center_details";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_TRANSFER_PAGE"] = "tap_btn_continue_transfer_page ";
    ElectronicsFnolTrackEvents["TAP_BTN_ADD_DETAILS_TRANSFER_PAGE"] = "tap_btn_add_details_transfer_page";
    ElectronicsFnolTrackEvents["TAP_BTN_CONFIRM_UPI_DETAILS"] = "tap_btn_confirm_upi_details";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_UPI_DETAILS"] = "tap_btn_continue_upi_details";
    ElectronicsFnolTrackEvents["TAP_BTN_CONFIRM_BANK_DETAILS"] = "tap_btn_confirm_bank_details";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_BANK_DETAILS"] = "tap_btn_continue_bank_details";
    ElectronicsFnolTrackEvents["TAP_BTN_CONTINUE_REVIEW_REQUEST_DETAILS"] = "tap_btn_continue_review_request_details ";
    ElectronicsFnolTrackEvents["TAP_BTN_TRACK_REQUEST_REGISTERED"] = "tap_btn_track_request_registered";
    ElectronicsFnolTrackEvents["TAP_BTN_WITHDRAW_CLAIM_TRACK_REPAIR_REQUEST"] = "tap_btn_withdraw_claim_track_repair_request";
    ElectronicsFnolTrackEvents["TAP_BTN_WITHDRAW_CLAIM_WITHDRAW_POPUP"] = "tap_btn_withdraw_claim_withdraw_popup";
    ElectronicsFnolTrackEvents["AVAILABLE_CLAIM_MODES_DURING_MOBILE_FNOL"] = "available_claim_modes_during_mobile_fnol";
})(ElectronicsFnolTrackEvents || (ElectronicsFnolTrackEvents = {}));
var ElectronicsFnolPages;
(function(ElectronicsFnolPages) {
    ElectronicsFnolPages["IMEI_SCREEN"] = "imei_screen";
    ElectronicsFnolPages["MOBILE_DAMAGE_TYPE_SCREEN"] = "mobile_damage_type_screen";
    ElectronicsFnolPages["INCIDENT_DETAILS_SCREEN"] = "incident_details_screen";
    ElectronicsFnolPages["PINCODE_SCREEN"] = "pincode_screen";
    ElectronicsFnolPages["SETTLEMENT_MODE_PAGE"] = "settlement_mode_page";
    ElectronicsFnolPages["ADD_SPARE_PHONE_PAGE"] = "add_spare_phone_page";
    ElectronicsFnolPages["PICK_UP_ADDRESS_PAGE"] = "pick_up_address_page";
    ElectronicsFnolPages["UPLOAD_PHOTO_REIMBURSEMENT_FLOW"] = "upload_photo_reimbursement_flow";
    ElectronicsFnolPages["SERVICE_CENTER_DETAILS"] = "service_center_details";
    ElectronicsFnolPages["PAYMENT_SCREEN"] = "payment_screen";
    ElectronicsFnolPages["REQUEST_DETAILS_SCREEN"] = "request_details_screen";
    ElectronicsFnolPages["TRACK_REQUEST_SCREEN"] = "track_request_screen";
    ElectronicsFnolPages["WITHDRAW_CLAIM_SCREEN"] = "withdraw_claim_screen";
    ElectronicsFnolPages["POLICY_DETAIL_PAGE"] = "policy_detail_page";
})(ElectronicsFnolPages || (ElectronicsFnolPages = {}));
var MPosSegmentViewEvents;
(function(MPosSegmentViewEvents) {
    MPosSegmentViewEvents["VIEW_LOGIN_CUSTOMER"] = "view_pos_login_customer";
    MPosSegmentViewEvents["VIEW_CUSTOMER_CONFIRMATION_PAGE"] = "view_pos_customer_confirmation_page";
    MPosSegmentViewEvents["VIEW_PLAN_DETAILS_PAGE_CUSTOMER"] = "view_pos_plan_details_page_customer";
    MPosSegmentViewEvents["VIEW_CUSTOMER_SUCCESS_SCREEN"] = "view_pos_customer_success_screen";
    MPosSegmentViewEvents["VIEW_PAYMENT_SUCCESS_SCREEN"] = "view_payment_success_screen";
    MPosSegmentViewEvents["VIEW_PAYMENT_FAILURE_SCREEN"] = "view_payment_failure_screen";
})(MPosSegmentViewEvents || (MPosSegmentViewEvents = {}));
var MPosSegementTrackEvents;
(function(MPosSegementTrackEvents) {
    MPosSegementTrackEvents["TAP_CTA_VIEW_DETAILS"] = "tap_pos_cta_view_details";
    MPosSegementTrackEvents["TAP_CTA_TNC_CUSTOMER"] = "tap_pos_cta_tnc_customer";
    MPosSegementTrackEvents["TAP_BTN_PAY_TO_DEALER"] = "tap_pos_btn_pay_to_dealer";
    MPosSegementTrackEvents["TAP_BTN_PAY_ONLINE"] = "tap_pos_btn_pay_online";
    MPosSegementTrackEvents["TAP_BTN_DOWNLOAD_THE_APP"] = "tap_pos_btn_download_the_app";
})(MPosSegementTrackEvents || (MPosSegementTrackEvents = {}));
var MPosSegmentPages;
(function(MPosSegmentPages) {
    MPosSegmentPages["CUSTOMER_LOGIN"] = "customer_login";
    MPosSegmentPages["CUSTOMER_CONFIRMATION"] = "customer_confirmation";
    MPosSegmentPages["PLAN_DETAILS"] = "plan_details";
    MPosSegmentPages["CUSTOMER_SUCCESS"] = "customer_success";
})(MPosSegmentPages || (MPosSegmentPages = {}));
var SegmentViewEvents;
(function(SegmentViewEvents) {
    SegmentViewEvents["VIEW_PAGE_ONBOARDING_LANDING"] = "view_page_onboarding_landing";
    SegmentViewEvents["VIEW_PAGE_USER_DETAILS"] = "view_page_user_details";
    SegmentViewEvents["VIEW_PAGE_LOADER"] = "view_page_loader";
    SegmentViewEvents["VIEW_PAGE_CAR_REGISTRATION_NUMBER"] = "view_page_car_registration_number";
    SegmentViewEvents["VIEW_PAGE_VOUCHER"] = "view_page_voucher";
    SegmentViewEvents["VIEW_BANNER_VOUCHER"] = "view_banner_voucher";
})(SegmentViewEvents || (SegmentViewEvents = {}));
var SegmentTrackEvents;
(function(SegmentTrackEvents) {
    SegmentTrackEvents["TAP_BTN_CONTINUE_LANDING_PAGE"] = "tap_btn_continue_landing_page";
    SegmentTrackEvents["TAP_BTN_CONTINUE_USER_DETAILS_PAGE"] = "tap_btn_continue_user_details_page";
    SegmentTrackEvents["TAP_BTN_CLOSE_MODAL_CAR_NUMBER_MODAL"] = "tap_btn_close_modal_car_number_modal";
    SegmentTrackEvents["TAP_BTN_GET_COUPON_CAR_NUMBER_MODAL"] = "tap_btn_get_coupon_car_number_modal";
    SegmentTrackEvents["TAP_BTN_NO_CAR_CAR_NUMBER_MODAL"] = "tap_btn_no_car_car_number_modal";
    SegmentTrackEvents["TAP_BTN_CLOSE_VOUCHER_MODAL"] = "tap_btn_close_voucher_modal";
    SegmentTrackEvents["TAP_BTN_VIEW_PLAN_VOUCHER_MODAL"] = "tap_btn_view_plan_voucher_modal";
    SegmentTrackEvents["TAP_BTN_REDEEM_VOUCHER_POLICY_DETAIL_PAGE"] = "tap_btn_redeem_voucher_policy_detail_page";
})(SegmentTrackEvents || (SegmentTrackEvents = {}));
var InternetFnolTrackEvents;
(function(InternetFnolTrackEvents) {
    InternetFnolTrackEvents["TAP_BTN_VIEW_DOC_SAMPLE"] = "tap_btn_view_doc_sample";
    InternetFnolTrackEvents["TAP_BTN_VIEW_DOC_INFO"] = "tap_btn_view_doc_info";
    InternetFnolTrackEvents["TAP_BTN_UPLOAD_DOCUMENT"] = "tap_btn_upload_document";
    InternetFnolTrackEvents["UPLOAD_DOCUMENT_SUCCESS"] = "upload_document_success";
    InternetFnolTrackEvents["UPLOAD_DOCUMENT_TO_JARVIS_INIT"] = "upload_document_to_jarvis_init";
    InternetFnolTrackEvents["UPLOAD_DOCUMENT_TO_JARVIS_SUCCESS"] = "upload_document_to_jarvis_success";
    InternetFnolTrackEvents["SEND_JARVIS_EVENT_INIT"] = "send_jarvis_event_init";
    InternetFnolTrackEvents["SEND_JARVIS_EVENT_SUCCESS"] = "send_jarvis_event_success";
    InternetFnolTrackEvents["TAP_BTN_ADD_MORE_DOCUMENTS"] = "tap_btn_add_more_documents";
    InternetFnolTrackEvents["TAP_BTN_DELETE_UPLOADED_DOCUMENTS"] = "tap_btn_delete_uploaded_documents";
    InternetFnolTrackEvents["TAP_CONTINUE_FROM_DOCUMENT_UPLOAD"] = "tap_continue_from_document_upload";
    InternetFnolTrackEvents["TAP_BACK_FROM_DOCUMENT_UPLOAD"] = "tap_back_from_document_upload";
    InternetFnolTrackEvents["TAP_BTN_DOC_PAGE_CONTINUE"] = "tap_btn_doc_page_continue";
    InternetFnolTrackEvents["TAP_BTN_PAYMENT_MODE_SELECTION"] = "tap_btn_payment_mode_selection";
    InternetFnolTrackEvents["TAP_BTN_PAYMENT_SCREEN_CONTINUE"] = "tap_btn_payment_screen_continue";
    InternetFnolTrackEvents["TAP_BTN_ADD_NEW_PAYMENT_DETAILS"] = "tap_btn_add_new_payment_details";
    InternetFnolTrackEvents["TAP_BTN_EDIT_CLAIM"] = "tap_btn_edit_claim";
    InternetFnolTrackEvents["TAP_BTN_TRACK_CLAIM"] = "tap_btn_track_claim";
    InternetFnolTrackEvents["TAP_BTN_DECLARATION"] = "tap_btn_declaration";
    InternetFnolTrackEvents["TAP_BTN_CLAIM"] = "tap_btn_claim";
    InternetFnolTrackEvents["TAP_BTN_POLICY_DOCUMENT"] = "tap_btn_policy_document";
    InternetFnolTrackEvents["TAP_BTN_POLICY_DOCUMENT_DOWNLOAD"] = "tap_btn_policy_document_download";
    InternetFnolTrackEvents["TAP_BTN_EMAIL_POLICY"] = "tap_btn_email_policy";
    InternetFnolTrackEvents["TAP_BTN_SMS_POLICY"] = "tap_btn_sms_policy";
    InternetFnolTrackEvents["SELECT_FIELD_VALUE"] = "select_field_value";
    InternetFnolTrackEvents["TAP_BTN_GET_DOCUMENT"] = "tap_btn_get_document";
    InternetFnolTrackEvents["TAP_BTN"] = "tap_btn";
})(InternetFnolTrackEvents || (InternetFnolTrackEvents = {}));
var InternetFnolViewEvents;
(function(InternetFnolViewEvents) {
    InternetFnolViewEvents["VIEW_UPLOAD_DOCUMENTS"] = "view_document_upload_page";
    InternetFnolViewEvents["VIEW_DOCUMENT_UPLOAD_MODAL"] = "view_document_upload_modal";
    InternetFnolViewEvents["VIEW_PAYMENT_SCREEN"] = "view_internet_fnol_payment_screen";
    InternetFnolViewEvents["VIEW_THANKYOU"] = "view_internet_fnol_thank_you";
    InternetFnolViewEvents["VIEW_ERROR_DOC_UPLOAD"] = "view_error_doc_upload";
    InternetFnolViewEvents["VIEW_PENNY_DROP_VERIFICATION_ERROR"] = "view_penny_drop_verification_error";
    InternetFnolViewEvents["VIEW_POLICY_DISPLAY_PAGE"] = "view_policy_display_page";
    InternetFnolViewEvents["VIEW_GET_POLICY_DOCUMENT_MODAL"] = "view_get_policy_document_modal";
    InternetFnolViewEvents["VIEW_SMS_POLICY_MODAL"] = "view_sms_policy_modal";
    InternetFnolViewEvents["VIEW_EMAIL_POLICY_MODAL"] = "view_email_policy_modal";
    InternetFnolViewEvents["VIEW_ADD_DEPENDANT_MODAL"] = "view_add_dependant_modal";
    InternetFnolViewEvents["VIEW_PDP_HEALTH_CARD"] = "view_pdp_health_card";
    InternetFnolViewEvents["VIEW_SELECT_ONGOING_CLAIMS_PAGE"] = "view_select_ongoing_claim_pages";
    InternetFnolViewEvents["VIEW_PRIMARY_COVER_SELECTION_PAGE"] = "view_primary_cover_selection_page";
    InternetFnolViewEvents["VIEW_SECONDARY_COVER_SELECTION_PAGE"] = "view_secondary_cover_selection_page";
    InternetFnolViewEvents["VIEW_REVIEW_CLAIM_DETAILS_PAGE"] = "view_review_claim_details_page";
    InternetFnolViewEvents["VIEW_ADD_NOMINEE_MODAL"] = "view_add_nominee_modal";
    InternetFnolViewEvents["VIEW_EDIT_NOMINEE_MODAL"] = "view_edit_nominee_modal";
})(InternetFnolViewEvents || (InternetFnolViewEvents = {}));
var InternetFnolPageTypes;
(function(InternetFnolPageTypes) {
    InternetFnolPageTypes["DOCUMENT_UPLOAD_PAGE"] = "document_upload_main_page";
    InternetFnolPageTypes["DOCUMENT_UPLOAD_MODAL"] = "document_upload_modal";
    InternetFnolPageTypes["PDP_MAIN_PAGE"] = "pdp_main_page";
    InternetFnolPageTypes["PDP_GET_POLICY_DOCUMENT_MODAL"] = "pdp_get_policy_document_modal";
    InternetFnolPageTypes["PDP_EMAIL_POLICY_MODAL"] = "pdp_email_policy_modal";
    InternetFnolPageTypes["PDP_SMS_POLICY_MODAL"] = "pdp_sms_policy_modal";
    InternetFnolPageTypes["PDP_ADD_DEPENDANT_MODAL"] = "pdp_add_dependant_modal";
    InternetFnolPageTypes["PDP_ADD_NOMINEE_MODAL"] = "pdp_add_nominee_modal";
    InternetFnolPageTypes["PDP_EDIT_NOMINEE_MODAL"] = "pdp_edit_nominee_modal";
    InternetFnolPageTypes["PDP_HEALTH_CARD"] = "pdp_health_card";
    InternetFnolPageTypes["SELECT_ONGOING_CLAIM"] = "select_ongoing_claim";
    InternetFnolPageTypes["PDP_ADD_DEPENDENT_MODAL"] = "pdp_add_dependent_modal";
    InternetFnolPageTypes["PDP_TRACK_ONGOING_CLAIMS"] = "pdp_track_ongoing_claims";
    InternetFnolPageTypes["COVER_SELECTION_MAIN_PAGE"] = "cover_selection_main_page";
    InternetFnolPageTypes["WHO_WAS_AFFECTED_MAIN_PAGE"] = "who_was_affected_main_page";
    InternetFnolPageTypes["INSURED_DETAILS_MAIN_PAGE"] = "insured_details_main_page";
    InternetFnolPageTypes["INSURED_DETAILS_RELATION_DROPDOWN"] = "insured_details_relation_dropdown";
    InternetFnolPageTypes["INSURED_DETAILS_GENDER_DROPDOWN"] = "insured_details_gender_dropdown";
    InternetFnolPageTypes["INSURED_DETAILS_CITY_DROPDOWN"] = "insured_details_city_dropdown";
    InternetFnolPageTypes["INSURED_DETAILS_DOB_DATEPICKER"] = "insured_details_dob_datepicker";
    InternetFnolPageTypes["INCIDENT_DETAILS_MAIN_PAGE"] = "incident_details_main_page";
    InternetFnolPageTypes["TRACK_CLAIM_MAIN_PAGE"] = "track_claim_main_page";
    InternetFnolPageTypes["REVIEW_MAIN_PAGE"] = "review_main_page";
    InternetFnolPageTypes["REVIEW_EDIT_SUMMARY_MODAL"] = "review_edit_summary_modal";
    InternetFnolPageTypes["SELECT_PAYEE_MAIN_PAGE"] = "select_payee_main_page";
})(InternetFnolPageTypes || (InternetFnolPageTypes = {}));
var InternetFnolPages;
(function(InternetFnolPages) {
    InternetFnolPages["DOCUMENT_UPLOAD"] = "document_upload";
    InternetFnolPages["POLICY_DISPLAY_PAGE"] = "policy_display_page";
    InternetFnolPages["ONGOING_CLAIMS_PAGE"] = "ongoing_claims_page";
    InternetFnolPages["PRIMARY_COVER_SELECTION"] = "primary_cover_selection";
    InternetFnolPages["SECONDARY_COVER_SELECTION"] = "secondary_cover_selection";
    InternetFnolPages["WHO_WAS_AFFECTED"] = "who_was_affected";
    InternetFnolPages["INSURED_DETAILS"] = "insured_details";
    InternetFnolPages["INCIDENT_DETAILS"] = "incident_details";
    InternetFnolPages["TRACK_CLAIM"] = "track_claim";
    InternetFnolPages["REVIEW_CLAIM_DETAILS"] = "review_claim_details";
    InternetFnolPages["SELECT_WHOM_YOU_WANT_TO_PAY"] = "select_whom_you_want_to_pay";
})(InternetFnolPages || (InternetFnolPages = {}));
var InternetFnolButton;
(function(InternetFnolButton) {
    InternetFnolButton["ADD_MORE_DOCUMENTS"] = "add_more_documents";
    InternetFnolButton["UPLOAD_DOCUMENT"] = "upload_document";
    InternetFnolButton["DELETE_UPLOADED_DOCUMENT"] = "delete_uploaded_document";
    InternetFnolButton["CONTINUE_FROM_DOCUMENT_UPLOAD"] = "continue_from_document_upload";
    InternetFnolButton["BACK_FROM_DOCUMENT_UPLOAD"] = "back_from_document_upload";
    InternetFnolButton["VIEW_DOC_SAMPLE"] = "view_doc_sample";
    InternetFnolButton["BUTTON_INFO"] = "button_info";
    InternetFnolButton["CLAIM"] = "claim";
    InternetFnolButton["POLICY_DOCUMENT"] = "policy_document";
    InternetFnolButton["DOWNLOAD_POLICY_DOCUMENT"] = "download_policy_document";
    InternetFnolButton["EMAIL_POLICY_DOCUMENT"] = "email_policy_document";
    InternetFnolButton["SMS_POLICY_DOCUMENT"] = "sms_policy_document";
    InternetFnolButton["ENTER_PHONE_NUMBER"] = "enter_phone_number";
    InternetFnolButton["ENTER_EMAIL_ID"] = "enter_email_id";
    InternetFnolButton["GET_DOCUMENT"] = "get_document";
    InternetFnolButton["HEALTH_CARD"] = "health_card";
    InternetFnolButton["TELECONSULTATION_INSTALL"] = "teleconsultation_install";
    InternetFnolButton["ADD_DEPENDANT"] = "add_dependant";
    InternetFnolButton["EDIT_NOMINEE"] = "edit_nominee";
    InternetFnolButton["ENTER_NAME"] = "enter_name";
    InternetFnolButton["ENTER_DOB"] = "enter_dob";
    InternetFnolButton["ENTER_RELATION"] = "enter_relation";
    InternetFnolButton["CONTINUE"] = "continue";
    InternetFnolButton["CROSS_SELL"] = "cross_sell";
    InternetFnolButton["BACK_FROM_POLICY_DOCUMENT"] = "back_from_policy_document";
    InternetFnolButton["BACK_FROM_EMAIL_POLICY_MODAL"] = "back_from_email_policy_modal";
    InternetFnolButton["BACK_FROM_SMS_POLICY_MODAL"] = "back_from_sms_policy_modal";
    InternetFnolButton["BACK_FROM_ADD_DEPENDENT_MODAL"] = "back_from_add_dependent_modal";
    InternetFnolButton["SELECT_ONGOING_CLAIM"] = "select_ongoing_claim";
    InternetFnolButton["TRACK_ONGOING_CLAIMS"] = "track_ongoing_claims";
    InternetFnolButton["BACK_FROM_SECONDARY_COVER_SELECTION"] = "back_from_secondary_cover_selection";
    InternetFnolButton["BACK_FROM_PRIMARY_COVER_SELECTION"] = "back_from_primary_cover_selection";
    InternetFnolButton["BACK_FROM_WHO_WAS_AFFECTED"] = "back_from_who_was_affected";
    InternetFnolButton["ENTER_GENDER"] = "enter_gender";
    InternetFnolButton["ENTER_CITY"] = "enter_city";
    InternetFnolButton["CONTINUE_FROM_INSURED_SELECTION"] = "continue_from_insured_selection";
    InternetFnolButton["CONTINUE_FROM_INCIDENT_DETAILS"] = "continue_from_incident_details";
    InternetFnolButton["BACK_FROM_INCIDENT_DETAILS"] = "back_from_incident_details";
    InternetFnolButton["TRACK_REQUEST"] = "track_request";
    InternetFnolButton["SUBMIT_REVIEW_CLAIM_DETAILS"] = "submit_review_claim_details";
    InternetFnolButton["BACK_FROM_REVIEW_CLAIM_DETAILS"] = "back_from_review_claim_details";
    InternetFnolButton["TOGGLE_WHATSAPP_UPDATES"] = "toggle_whatsapp_updates";
    InternetFnolButton["TOGGLE_DECLARATION_CONSENT"] = "toggle_declaration_consent";
    InternetFnolButton["OPEN_EDIT_SUMMARY_MODAL"] = "open_edit_summary_modal";
    InternetFnolButton["SELECT_PAYEE"] = "select_payee";
    InternetFnolButton["BACK_FROM_SELECT_PAYEE"] = "back_from_select_payee";
    InternetFnolButton["SELECT_GUARDIAN"] = "select_guardian";
    InternetFnolButton["SUBMIT_FROM_SELECT_PAYEE"] = "submit_from_select_payee";
})(InternetFnolButton || (InternetFnolButton = {}));
var EWFnolViewEvents;
(function(EWFnolViewEvents) {
    EWFnolViewEvents["VIEW_PAGE_PINCODE"] = "view_page_pincode";
    EWFnolViewEvents["VIEW_PAGE_POPUP_PINCODE"] = "view_page_popup_pincode";
    EWFnolViewEvents["VIEW_PAGE_LOSS_INFORMATION"] = "view_page_loss_information";
    EWFnolViewEvents["VIEW_PAGE_INCIDENT_DATE_INFORMATION"] = "view_page_address_information";
    EWFnolViewEvents["VIEW_PAGE_ADDRESS_INFORMATION"] = "view_page_address_details";
    EWFnolViewEvents["VIEW_PAGE_ADD_ADDRESS"] = "view_page_add_address";
    EWFnolViewEvents["VIEW_PAGE_PREFERRED_VISIT_DATE"] = "view_page_preferred_visit_date";
    EWFnolViewEvents["VIEW_PAGE_REQUEST_SUMMARY"] = "view_page_request_summary";
    EWFnolViewEvents["VIEW_PAGE_REQUEST_REGISTERED"] = "view_page_request_registered";
    EWFnolViewEvents["VIEW_PAGE_TRACK_REPAIR_REQUEST"] = "view_page_track_repair_request";
    EWFnolViewEvents["VIEW_PAGE_CONFIRM_CLAIM_WITHDRAW_POPUP"] = "view_page_confirm_claim_withdraw_popup";
    EWFnolViewEvents["VIEW_PAGE_REQUEST_CREATED"] = "view_page_request_created";
})(EWFnolViewEvents || (EWFnolViewEvents = {}));
var EWFnolTrackEvents;
(function(EWFnolTrackEvents) {
    EWFnolTrackEvents["TAP_BTN_BACK"] = "tap_btn_back";
    EWFnolTrackEvents["TAP_BTN_DAMAGE_TYPE"] = "tap_btn_mobile_damage_type";
    EWFnolTrackEvents["TAP_BTN_CONTINUE_LOSS_INFORMATION"] = "tap_btn_continue_loss_information";
    EWFnolTrackEvents["TAP_BTN_INCIDENT_CONTINUE_INCIDENT_DATE_INFORMATION"] = "tap_btn_continue_incident_date_information";
    EWFnolTrackEvents["TAP_BTN_INCIDENT_DESCRIPTION_INCIDENT_DETAIL_PAGE"] = "tap_btn_incident_description_incident_detail_page";
    EWFnolTrackEvents["TAP_INPUT_INCIDENT_DESCRIPTION_INCIDENT_DETAIL_PAGE"] = "tap_input_incident_description_incident_detail_page";
    EWFnolTrackEvents["TAP_BTN_CONTINUE_INCIDENT_DETAIL_PAGE"] = "tap_btn_continue_incident_detail_page";
    EWFnolTrackEvents["TAP_BTN_CONTINUE_POP_UP_PINCODE"] = "tap_btn_continue_pop_up_pincode";
    EWFnolTrackEvents["TAP_BTN_CONTINUE_REVIEW_REQUEST_DETAILS"] = "tap_btn_continue_review_request_details ";
    EWFnolTrackEvents["TAP_BTN_TRACK_REQUEST"] = "tap_btn_track_request";
    EWFnolTrackEvents["TAP_BTN_WITHDRAW_CLAIM_TRACK_REPAIR_REQUEST"] = "tap_btn_withdraw_claim_track_repair_request";
    EWFnolTrackEvents["TAP_BTN_WITHDRAW_CLAIM_WITHDRAW_POPUP"] = "tap_btn_withdraw_claim_withdraw_popup";
    EWFnolTrackEvents["TAP_BTN_SELECT_ADDRESS"] = "tap_btn_select_address";
    EWFnolTrackEvents["TAP_BTN_ADD_ADDRESS"] = "tap_btn_add_address";
    EWFnolTrackEvents["TAP_BTN_SAVE_ADD_ADDRESS"] = "tap_btn_save_add_address";
    EWFnolTrackEvents["TAP_BTN_SUBMIT_PREFERRED_VISIT_DATE"] = "tap_btn_submit_preferred_visit_date";
    EWFnolTrackEvents["TAP_BTN_SUBMIT_REQUEST_SUMMARY"] = "tap_btn_submit_request_summary";
})(EWFnolTrackEvents || (EWFnolTrackEvents = {}));
var EWFnolPages;
(function(EWFnolPages) {
    EWFnolPages["POLICY_DETAIL_PAGE"] = "policy_detail_page";
    EWFnolPages["PINCODE_SCREEN"] = "pincode_screen";
    EWFnolPages["PINCODE_POP_UP"] = "pincode_pop_up";
    EWFnolPages["DAMAGE_SCREEN"] = "damage_screen";
    EWFnolPages["INCIDENT_INFORMATION"] = "incident information";
    EWFnolPages["ADDRESS_INFORMATION"] = "address_information";
    EWFnolPages["ADD_ADDRESS_SCREEN"] = "add_address_screen";
    EWFnolPages["SCHEDULE_VISIT_SCREEN"] = "schedule_visit_screen";
    EWFnolPages["REVIEW_SUMMARY"] = "review_summary";
    EWFnolPages["REQUEST_CREATED"] = "request_created";
    EWFnolPages["TRACK_REQUEST_SCREEN"] = "track_request_screen";
    EWFnolPages["WITHDRAW_CLAIM_SCREEN"] = "withdraw_claim_screen";
})(EWFnolPages || (EWFnolPages = {}));


/***/ })

}]);